export default __webpack_public_path__ + "static/media/038-adjustable wrench.0a0b6561.svg";